import { render, staticRenderFns } from "./DetailThesis.vue?vue&type=template&id=c30a814a&scoped=true"
import script from "./DetailThesis.vue?vue&type=script&lang=js"
export * from "./DetailThesis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30a814a",
  null
  
)

export default component.exports